import * as React from 'react';
import DOMPurify from 'dompurify';

// Single place that renders trusted-but-unescaped HTML (admin-authored config,
// index-sourced markdown). Centralizes the DOMPurify policy so a future allowlist
// change lives in one spot instead of every `dangerouslySetInnerHTML` call site.
// `as` picks the wrapper element; remaining props (className, …) pass through.
export default function SanitizedHtml({html, as: Tag = 'div', ...props}) {
  return (
    <Tag {...props} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(`${html ?? ''}`, {ADD_ATTR: ['target', 'rel']})}}/>
  );
}
